export enum ApiRoutesDashboard {
  Statistics = "admin/profit-and-loss/statistics",
  SocialSources = "admin/product-sharings/statistics",
  TopSellingCategories = "category-admin/top-selling/all"
}
